export default __webpack_public_path__ + "static/media/GR6 6B-2EC.cc6d88f4.jpg";